import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoMark = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 65,
	height: 48,
	viewBox: "0 0 65 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M64.1451 23.7598L40.4477 47.5197C27.3612 34.3971 27.3612 13.1226 40.4477 0L64.1451 23.7598Z",
			fill: "#3FB3B4"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54.0004 23.7598L30.3041 47.5197C17.2176 34.3971 17.2176 13.1226 30.3041 0L54.0004 23.7598Z",
			fill: "#2F8C94"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M43.5462 23.7598L19.8498 47.5197C6.7623 34.3971 6.7623 13.1226 19.8498 0L43.5462 23.7598Z",
			fill: "#005369"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M33.512 23.7598L9.81565 47.5197C-3.27188 34.3971 -3.27188 13.1226 9.81565 0L33.512 23.7598Z",
			fill: "#003C56"
		})
	]
});
const ForwardRef = forwardRef(SvgLogoMark);
export default ForwardRef;
